import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=4001fe6a&scoped=true&"
import script from "./Activities.vue?vue&type=script&lang=ts&"
export * from "./Activities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4001fe6a",
  null
  
)

export default component.exports